import * as R from "ramda";
import moment from "moment-timezone";

export const transformFromApi = step =>
  R.pipe(
    R.when(
      R.hasPath(["config", "days", 0]),
      R.pipe(
        R.assocPath(
          ["config", "schedule", "from"],
          moment(R.path(["config", "days", 0, "from"], step))
        ),
        R.assocPath(
          ["config", "schedule", "to"],
          moment(R.path(["config", "days", 0, "to"], step))
        )
      )
    ),
    R.evolve({
      config: {
        users: R.pipe(
          R.defaultTo([]),
          R.when(
            R.both(R.complement(R.has("key")), R.length), // If is not already formatted for the form
            R.pipe(
              R.head,
              user => ({
                key: user.id,
                label: user.name
              })
            )
          )
        ),
        days: R.map(R.prop("day"))
      }
    })
  )(step);

export const transformToApi = (values, omitValues = []) =>
  R.pipe(
    R.when(
      R.hasPath(["config", "schedule"]),
      R.pipe(
        R.evolve({
          config: {
            users: R.ifElse(
              R.prop("key"),
              R.pipe(
                R.of,
                R.map(user => ({
                  id: user.key,
                  name: user.label
                }))
              ),
              R.always([])
            ),
            days: R.map(dayNumber => ({
              from: moment
                .utc(
                  moment()
                    .hour(values.config.schedule.from.hour())
                    .minute(values.config.schedule.from.minute())
                    .seconds(0)
                    .toDate()
                )
                .valueOf(),
              to: moment
                .utc(
                  moment()
                    .hour(values.config.schedule.to.hour())
                    .minute(values.config.schedule.to.minute())
                    .seconds(0)
                    .toDate()
                )
                .valueOf(),
              day: dayNumber
            }))
          }
        }),
        R.dissocPath(["config", "schedule"])
      )
    ),
    R.when(
      // If users is not an array, make it into one
      R.path(["config", "users", "key"]),
      step =>
        R.assocPath(
          ["config", "users"],
          [
            {
              id: R.path(["config", "users", "key"], step),
              name: R.path(["config", "users", "label"], step)
            }
          ],
          step
        )
    ),
    R.dissocPath(["config", "documents"]),
    R.dissocPath(["config", "customDocumentTypeName"]),
    R.dissocPath(["config", "documentRequirementKey"]),
    R.omit([
      ...omitValues,
      "matches",
      "_id",
      "unsaved",
      "unvalidated",
      values.id && values.id.startsWith("temp-") ? "id" : undefined
    ])
  )(values);
